module.exports = __webpack_public_path__ + "static/media/page-next.d6653317.svg";